module.exports = __webpack_public_path__ + "co.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/co.svg
// module id = 499
// module chunks = 0